import React from 'react';

import { DraftEditorProps, TableColumnEditor } from '../field-widgets';
import { AggregationDraft } from 'src/feature-descriptor/feature-descriptor-editor/models';

export const TopicEditor = (props: DraftEditorProps<AggregationDraft>) => {
  return [
    <TableColumnEditor
      key="text_topic_field"
      label="text_topic_field"
      {...props}
    />,
    <TableColumnEditor
      key="original_text_column_name"
      label="original_text_column_name"
      {...props}
    />,
  ];
};
